import { render, staticRenderFns } from "./DesiScale.vue?vue&type=template&id=74830763&scoped=true&"
import script from "./DesiScale.vue?vue&type=script&lang=js&"
export * from "./DesiScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74830763",
  null
  
)

export default component.exports